module.exports = __webpack_public_path__ + "img/sv102.30cdee04.svg";